// Calendar dates describe a day, independent of any timezone.
function calendarDateParts(value) {
  if (typeof value !== "string") return null;
  const text = value.trim();
  const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|[T ])/);
  const us = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:$|[T ])/);
  if (!iso && !us) return null;

  const year = Number(iso ? iso[1] : us[3]);
  const month = Number(iso ? iso[2] : us[1]);
  const day = Number(iso ? iso[3] : us[2]);
  const leapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const daysInMonth = [31, leapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (year < 1 || month < 1 || month > 12 || day < 1 || day > daysInMonth[month - 1]) {
    return null;
  }
  return { year, month, day };
}

export function formatCalendarDate(value) {
  if (!value) return "";
  const parts = calendarDateParts(value);
  if (!parts) return String(value).trim();
  return `${parts.month}/${parts.day}/${String(parts.year).padStart(4, "0")}`;
}

export function formatCalendarDateForInput(value) {
  const parts = calendarDateParts(value);
  if (!parts) return "";
  const year = String(parts.year).padStart(4, "0");
  const month = String(parts.month).padStart(2, "0");
  const day = String(parts.day).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getLocalCalendarDate(date = new Date()) {
  const year = String(date.getFullYear()).padStart(4, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function ageFromCalendarDate(value, today) {
  const birthday = calendarDateParts(value);
  if (!birthday) return null;
  let age = today.getFullYear() - birthday.year;
  const month = today.getMonth() + 1;
  if (month < birthday.month || (month === birthday.month && today.getDate() < birthday.day)) {
    age--;
  }
  return age;
}

export function calculateAge(value, today = new Date()) {
  const age = ageFromCalendarDate(value, today);
  return age !== null && age >= 0 ? age : "";
}

export function getAge(value, today = new Date()) {
  const age = ageFromCalendarDate(value, today);
  return age === null ? null : Math.max(0, age);
}
